/* Caroline Wolf — theme.js: drawers, mega menu, quantity steppers, announcement marquee, collection toolbar */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var openDrawer = null;
  var lastTrigger = null;

  function trapFocus(container, event) {
    var nodes = container.querySelectorAll(FOCUSABLE);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function setExpanded(id, value) {
    document.querySelectorAll('[data-drawer-open="' + id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
  }

  window.openDrawerById = function (id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) closeDrawer(openDrawer);
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.setAttribute('data-open', '');
    });
    document.body.classList.add('overflow-hidden');
    setExpanded(id, true);
    openDrawer = drawer;
    var panel = drawer.querySelector('.drawer__panel');
    var focusTarget = panel && panel.querySelector(FOCUSABLE);
    if (focusTarget) focusTarget.focus();
  };

  function closeDrawer(drawer) {
    drawer.removeAttribute('data-open');
    document.body.classList.remove('overflow-hidden');
    setExpanded(drawer.id, false);
    window.setTimeout(function () {
      if (!drawer.hasAttribute('data-open')) drawer.hidden = true;
    }, 350);
    if (openDrawer === drawer) openDrawer = null;
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      lastTrigger = opener;
      window.openDrawerById(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      var drawer = closer.closest('[data-drawer]');
      if (drawer) closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (openDrawer) {
        closeDrawer(openDrawer);
        return;
      }
      var openMega = document.querySelector('details[data-mega][open]');
      if (openMega) {
        openMega.removeAttribute('open');
        openMega.querySelector('summary').focus();
      }
    }
    if (event.key === 'Tab' && openDrawer) {
      trapFocus(openDrawer.querySelector('.drawer__panel'), event);
    }
  });

  /* Mega menu: hover on pointer devices, close others, close on outside click */
  var megas = document.querySelectorAll('details[data-mega]');
  var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

  megas.forEach(function (mega) {
    var closeTimer = null;
    mega.addEventListener('toggle', function () {
      var summary = mega.querySelector('summary');
      summary.setAttribute('aria-expanded', mega.open ? 'true' : 'false');
      if (mega.open) {
        megas.forEach(function (other) {
          if (other !== mega) other.removeAttribute('open');
        });
      }
    });
    mega.addEventListener('pointerenter', function () {
      if (!hoverCapable.matches) return;
      window.clearTimeout(closeTimer);
      mega.setAttribute('open', '');
    });
    mega.addEventListener('pointerleave', function () {
      if (!hoverCapable.matches) return;
      closeTimer = window.setTimeout(function () {
        mega.removeAttribute('open');
      }, 150);
    });
    mega.addEventListener('focusout', function (event) {
      if (!mega.contains(event.relatedTarget)) mega.removeAttribute('open');
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('details[data-mega]')) {
      megas.forEach(function (mega) {
        mega.removeAttribute('open');
      });
    }
  });

  /* Quantity steppers */
  function syncQtyButtons(wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    var minus = wrapper.querySelector('[data-qty-change="-1"]');
    if (!input || !minus) return;
    var min = input.min === '' ? 0 : parseInt(input.min, 10);
    minus.disabled = (parseInt(input.value, 10) || 0) <= min;
  }
  document.querySelectorAll('.qty-input').forEach(syncQtyButtons);
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrapper = btn.closest('.qty-input');
    var input = wrapper && wrapper.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = input.min === '' ? 0 : parseInt(input.min, 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    syncQtyButtons(wrapper);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('input', function (event) {
    var wrapper = event.target.closest && event.target.closest('.qty-input');
    if (wrapper) syncQtyButtons(wrapper);
  });

  /* Reveal on scroll: one-shot fade/translate for [data-reveal]; siblings entering
     together are staggered. Static when reduced motion or no IntersectionObserver. */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealNodes = document.querySelectorAll('[data-reveal]');
  if (revealNodes.length) {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      revealNodes.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        var batch = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('--reveal-delay', Math.min(batch, 7) * 70 + 'ms');
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
          batch += 1;
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      revealNodes.forEach(function (el) { revealObserver.observe(el); });
      /* Sections rendered after load (related products, quick views) get observed too */
      if ('MutationObserver' in window) {
        new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
              if (node.nodeType !== 1) return;
              var found = node.matches('[data-reveal]') ? [node] : [];
              node.querySelectorAll('[data-reveal]').forEach(function (el) { found.push(el); });
              found.forEach(function (el) {
                if (!el.classList.contains('is-visible')) revealObserver.observe(el);
              });
            });
          });
        }).observe(document.body, { childList: true, subtree: true });
      }
    }
  }

  /* Parallax fallback for browsers without CSS scroll-driven animations.
     Only runs while a hero/banner is on screen (IntersectionObserver gate) and
     writes transform from a rAF loop; no scroll listener. */
  var supportsScrollTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  var parallaxImgs = document.querySelectorAll('.hero .hero__media img, .editorial .hero__media img');
  if (parallaxImgs.length && !supportsScrollTimeline && !reduceMotion.matches && 'IntersectionObserver' in window) {
    var active = [];
    var ticking = false;
    function paintParallax() {
      ticking = false;
      var vh = window.innerHeight;
      active.forEach(function (img) {
        var rect = img.parentElement.getBoundingClientRect();
        var progress = (vh - rect.top) / (vh + rect.height); /* 0 = entering, 1 = gone */
        var shift = (Math.min(1, Math.max(0, progress)) - 0.5) * 18; /* -9% .. 9% */
        img.style.transform = 'translate3d(0,' + shift.toFixed(2) + '%,0) scale(1.18)';
      });
      if (active.length) requestAnimationFrame(frame);
    }
    function frame() { if (!ticking) { ticking = true; paintParallax(); } }
    var parallaxObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = active.indexOf(entry.target);
        if (entry.isIntersecting && idx < 0) active.push(entry.target);
        if (!entry.isIntersecting && idx >= 0) active.splice(idx, 1);
      });
      if (active.length) requestAnimationFrame(frame);
    });
    parallaxImgs.forEach(function (img) { parallaxObserver.observe(img); });
  }

  /* Cookie consent banner */
  var cookieBanner = document.querySelector('[data-cookie-banner]');
  if (cookieBanner) {
    var CONSENT_KEY = 'cw:cookie-consent';
    var stored = null;
    try { stored = window.localStorage.getItem(CONSENT_KEY); } catch (e) { /* storage unavailable */ }

    function applyConsent(granted) {
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) {
            if (!error && window.Shopify.customerPrivacy) {
              window.Shopify.customerPrivacy.setTrackingConsent(granted, function () {});
            }
          }
        );
      }
    }

    function chooseConsent(granted) {
      try { window.localStorage.setItem(CONSENT_KEY, granted ? 'accepted' : 'declined'); } catch (e) { /* ignore */ }
      applyConsent(granted);
      cookieBanner.hidden = true;
    }

    if (stored === null) {
      cookieBanner.hidden = false;
    } else {
      applyConsent(stored === 'accepted');
    }
    cookieBanner.querySelector('[data-cookie-accept]').addEventListener('click', function () { chooseConsent(true); });
    cookieBanner.querySelector('[data-cookie-decline]').addEventListener('click', function () { chooseConsent(false); });
  }

  /* Announcement marquee: clone copies until the track always fills the screen.
     The keyframe shifts the track by 50%, so half the copies must be at least
     as wide as the marquee or an empty gap shows before the loop restarts. */
  document.querySelectorAll('.announcement-bar').forEach(function (bar) {
    var track = bar.querySelector('.marquee__track');
    if (!track || !track.children.length) return;
    var baseSpeed = parseFloat(bar.getAttribute('data-marquee-speed')) || 30;

    function fillTrack() {
      var first = track.children[0];
      var copyWidth = first.getBoundingClientRect().width;
      var marqueeWidth = track.parentElement.clientWidth;
      if (!copyWidth || !marqueeWidth) return;
      var needed = Math.ceil(marqueeWidth / copyWidth) * 2 + 2;
      while (track.children.length < needed) {
        var clone = first.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(function (link) { link.setAttribute('tabindex', '-1'); });
        track.appendChild(clone);
      }
      /* Keep pixels-per-second constant: the speed setting is calibrated for 4 copies. */
      bar.style.setProperty('--marquee-duration', (baseSpeed * track.children.length) / 4 + 's');
    }

    fillTrack();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fillTrack);
    var marqueeResizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(marqueeResizeTimer);
      marqueeResizeTimer = window.setTimeout(fillTrack, 150);
    });
  });

  /* Collection: sort select preserves current filters */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  /* Collection: strip empty fields from facet form submissions */
  var facetsForm = document.querySelector('[data-facets-form]');
  if (facetsForm) {
    facetsForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var params = new URLSearchParams();
      new FormData(facetsForm).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
      var target = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.location.assign(target);
    });
  }

  /* NEW badge: cards of the newest products (same list as the NEW page), fetched
     once per session; cards rendered later (home NEW IN row, related) included. */
  var newHandles = null;
  function badgeNewCards(root) {
    if (!newHandles) return;
    root.querySelectorAll('.card[data-product-handle]').forEach(function (card) {
      var media = card.querySelector('.card__media');
      if (!media || media.querySelector('.card__badge--new') || newHandles.indexOf(card.dataset.productHandle) === -1) return;
      var badge = document.createElement('span');
      badge.className = 'card__badge card__badge--new';
      badge.textContent = 'NEW';
      media.prepend(badge);
    });
  }
  if (document.querySelector('.card[data-product-handle]') || document.querySelector('[data-newest-grid]')) {
    var cacheKey = 'cw-new-handles';
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(cacheKey)); } catch (e) {}
    var loadHandles = cached && Date.now() - cached.t < 10 * 60 * 1000
      ? Promise.resolve(cached.handles)
      : fetch('/collections/all?view=new-handles&sort_by=created-descending')
          .then(function (res) { return res.json(); })
          .then(function (handles) {
            try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), handles: handles })); } catch (e) {}
            return handles;
          });
    loadHandles.then(function (handles) {
      newHandles = handles;
      badgeNewCards(document);
      if ('MutationObserver' in window) {
        new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) { if (node.nodeType === 1) badgeNewCards(node.parentNode || node); });
          });
        }).observe(document.body, { childList: true, subtree: true });
      }
    }).catch(function () {});
  }
})();
